export const MAX_TILES = 4;
